<template>
    <div class="mobile-menu menu" :class="{active: mobileMenuActive}">
        <span class="close-btn" @click="close"><img src="/img/close.svg"></span>
        <div class="content">
            <div class="title">Products</div>
            <div class="controls">
                <ul>
                    <li><a href="/live" class="sub-link">Live view</a></li>
                    <li><a href="/top" class="sub-link">Top charts</a></li>
                    <li><a href="/collections" class="sub-link">Collections</a></li>
                </ul>
            </div>

            <div class="title">Contacts</div>
            <a href="mailto: hello@storeglide.com" class="email">hello@storeglide.com</a>

            <div class="user-panel" v-if="authUser">
                <img :src="avatar" class="avatar">
                <a class="btn" href="/auth/logout">Log out</a>
            </div>
            <div class="wrapper-login" v-else>
                <button class="btn" type="button" data-toggle="modal" data-target="#loginModal" @click="close">Log in</button>
            </div>

            <div class="social-networks">
                <a href="https://vt.tiktok.com/yqTjdN/" target="_blank">
                    <img src="/img/tik_tok_social.svg"></a>
                <a href="https://instagram.com/storeglide?igshid=kkso8smkzn13" target="_blank">
                    <img src="/img/instagram_social.svg"></a>
                <a href="https://t.me/storeglide" target="_blank"  class="telegram">
                    <img src="/img/telegram_social.svg"></a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
    inheritAttrs: false,
    name: 'mobile-menu',
    computed: mapGetters(['mobileMenuActive']),
    methods: {
        ...mapMutations(['setMobileMenuNotActive']),
        close() {
            document.documentElement.classList.remove('blocked')
            document.body.classList.remove('blocked')
            this.setMobileMenuNotActive();
        }
    },
    data() {
        return {
            authUser: window.authUser,
            avatar: window.avatar
        };
    },
};
</script>

<style scoped lang="scss">
    .mobile-menu {
        display: none;
        height: 100%;
        width: 100%;
        background: #200033;
        position: absolute;
        top: 0;
        z-index: 100;
        padding: 15px;
        overflow-y: auto;
        max-height: 100%;
        &.active {
            display: block;
        }
        .close-btn {
            cursor: pointer;
            float: right;
        }
        .content {
            display: block;
            margin: 0 auto;
            width: 80%;
            text-align: center;
            .title {
                margin-top: 15px;
                font-weight: bold;
                font-size: 28px;
                color: #FFFFFF;
            }
            .controls {
                margin-bottom: 40px;
                ul {
                    padding: 0;
                    margin: 0;
                    li {
                        display: block;
                        margin-top: 15px;
                        a {
                            font-weight: 500;
                            font-size: 22px;
                            line-height: 27px;
                            color: #C3C3CA;
                        }
                    }
                }
            }
            .email {
                margin-top: 15px;
                display: inline-block;
                font-weight: 500;
                font-size: 22px;
                line-height: 27px;
                color: #C3C3CA;
            }
        }

        .user-panel {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 50px;
            .avatar {
                width: 40px;
                height: auto;
                border-radius: 40px;
                margin-right: 10px;
                position: relative;
                top: 1px;
            }
        }

        .wrapper-login {
            margin-top: 40px;
        }

        .btn {
            display: inline-block;
            background: #9240F5;
            border-radius: 20px;
            font-weight: 600;
            font-size: 20px;
            line-height: 24px;
            color: #ffffff;
            border: none;
            padding: 8px 25px;
        }

        .social-networks {
            margin-top: 60px;
            margin-bottom: 20px;
            a {
                padding-right: 20px;
                &:last-child {
                    padding-right: 0;
                }
            }
        }
    }
</style>

